import { useState, useMemo, useEffect } from 'react';
import { createUpdateSchedulesState, createHandleLiveProgress } from '@dtvgo/player-utils';
import { useGetSync } from '@dtvgo/react-utils';

function useLivePlayerSchedules(channelId, schedulesCache, fakeScheduleDefaultDurationMinutes, isDelayedWindowSecs) {
  const [state, setState] = useState({
    schedules: { current: void 0, next: void 0 },
    isLoading: false
  });
  const getChannelId = useGetSync(channelId);
  const getCurrentScheduleEndTime = useGetSync(state.schedules.current?.live.endTime);
  const updateState = useMemo(
    () => createUpdateSchedulesState(
      getChannelId,
      schedulesCache,
      setState,
      fakeScheduleDefaultDurationMinutes
    ),
    [fakeScheduleDefaultDurationMinutes, getChannelId, schedulesCache]
  );
  const handleProgress = useMemo(
    () => createHandleLiveProgress(updateState, getCurrentScheduleEndTime, isDelayedWindowSecs),
    [getCurrentScheduleEndTime, isDelayedWindowSecs, updateState]
  );
  useEffect(() => {
    updateState({
      currentTimestamp: Date.now(),
      useNowNext: true,
      hardUpdate: true
    }).catch((error) => {
      console.error("[@dtvgo/player-utils-react>usePlayerSchedules>useEffect(channelId) error", error);
      setState({ schedules: { current: void 0, next: void 0 }, isLoading: false });
    });
    return () => {
      setState({ schedules: { current: void 0, next: void 0 }, isLoading: false });
    };
  }, [channelId, updateState]);
  return [state, { handleProgress, updateState }];
}

export { useLivePlayerSchedules };
//# sourceMappingURL=useLivePlayerSchedules.js.map
